import './ContactUs.scss';

export const ContactUs = () => {
  return (
    <div className='container mb-5'>
      <div className='contact mx-auto'>
        <h2 className='text-center mb-3'>Love to Hear From You</h2>
        <p className='text-center'>
          Sed ullamcorper porta dictum. Integer a enim arcu. Fusce tellus justo,
          commodo at iaculis ut, faucibus eu arcu. Sed ut bibendum diam. Vivamus
          semper massa in lobortis ornare. Integer sed arcu accumsan, aliquet
          urna sagittis, rhoncus eros
        </p>
        <form action='https://www.example.com' method='post'>
          <div className='mb-3'>
            <label className='fw-bold form-label' htmlFor='input-text'>
              Full Name<span className='required-field'>*</span>
            </label>
            <input
              type='text'
              name='name'
              className='form-control'
              id='input-text'
              required
            />
          </div>
          <div className='mb-3'>
            <label className='fw-bold form-label' htmlFor='input-email'>
              Email<span className='required-field'>*</span>
            </label>
            <input
              type='email'
              name='email'
              className='form-control'
              id='input-email'
              required
            />
          </div>
          <div className='mb-3'>
            <label className='fw-bold form-label' htmlFor='input-message'>
              Message<span className='required-field'>*</span>
            </label>
            <textarea
              className='form-control'
              name='message'
              rows='5'
              id='input-message'
              required
            ></textarea>
          </div>
          <div className='text-end'>
            <button type='submit' className='btn btn-success fw-bold py-2 px-5'>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
